module.exports = "/static/images/sectional.png";